import { AGENT_TYPES } from "../constants/agentTypes";

const getSuggestedActionLabels = (agentName) => {
  switch (agentName) {
    case AGENT_TYPES.INTAKE_REVIEW_AGENT:
      return {
        runDuplicateLabel: "Run duplicate check for an application",
        saveLaterLabel: "Compare two applications",
      };
    case AGENT_TYPES.BENEFITS:
      return {
        runDuplicateLabel: "Run a benefit search",
        saveLaterLabel: "Check compliance risks",
      };
    case AGENT_TYPES.DOCUMENT:
      return {
        runDuplicateLabel: "Check application document quality",
        saveLaterLabel: "Identify any document issues",
      };
    case AGENT_TYPES.ELIGIBILITY_REVIEW:
      return {
        runDuplicateLabel: "Check eligibility of an application",
        saveLaterLabel: "Identify eligibility issues of an application",
      };
    case AGENT_TYPES.APPLICATION_STATUS:
      return {
        runDuplicateLabel: "Check an application's status",
        saveLaterLabel: "Identify application blockers",
      };
    default:
      return {
        runDuplicateLabel: "Run duplicate check on all applications",
        saveLaterLabel: "Save it for later",
      };
  }
};

export default getSuggestedActionLabels;